import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { PostHogWrapper } from './components/PostHogWrapper';
import 'mocks/registerMuiLicense';


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<React.StrictMode>
		<PostHogWrapper>
			<App />
		</PostHogWrapper>
	</React.StrictMode>
);
